import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { pageDefinition } from '../../data/pricingDetails';
export function PageDefinitionBox() {
  return <Section tone="surface" bordered labelledBy="page-definition-title" data-id="element-708" data-mp="hrj6lg41vmie">
      <Container data-id="element-709" data-mp="hsb1eoptpg7m">
        <Reveal data-id="element-710" data-mp="htvq3xpgi4xk">
          <div className="rounded-card border border-hairline bg-canvas p-8 lg:p-14" data-id="element-711" data-mp="3q730mhcjp8yi">
            <h2 id="page-definition-title" className="max-w-[20ch] text-[28px] leading-[1.15] tracking-[-0.03em] text-ink lg:text-[36px]" data-id="element-712" data-mp="3l886wkd1hzzm">
              What counts as a page?
            </h2>
            <p className="mt-5 max-w-measure text-body text-muted" data-id="element-713" data-mp="3v5ctumeplzhh">
              This is the one definition worth reading twice. Page count is what sets your price, so
              here is exactly how we count — agreed in writing before the project starts.
            </p>

            <div className="mt-12 grid gap-10 border-t border-hairline pt-10 md:grid-cols-2 md:gap-14" data-id="element-714" data-mp="2s6h0spi54q9x">
              <div data-id="element-715" data-mp="2x4sc74o338u9">
                <p className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-716" data-mp="2x48wzvptiyjx">Counts as a page</p>
                <ul className="mt-5 space-y-4" data-id="element-717" data-mp="317ye6045ydux">
                  {pageDefinition.counts.map(item => <li key={item} className="flex items-start gap-3" data-id="element-718" data-mp="364osoj0bl1e8">
                      <CheckIcon size={16} aria-hidden="true" className="mt-1 shrink-0 text-ink" data-id="element-719" data-mp="29gik5l0a1ouo" />
                      <span className="max-w-[42ch] text-small leading-6 text-ink" data-id="element-720" data-mp="2dgjao40nhqi3">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div data-id="element-721" data-mp="2n6uezro8y1pi">
                <p className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-722" data-mp="2n7dvr525uk1y">
                  Does not count as a page
                </p>
                <ul className="mt-5 space-y-4" data-id="element-723" data-mp="1ppnn5j389hgn">
                  {pageDefinition.doesNotCount.map(item => <li key={item} className="flex items-start gap-3" data-id="element-724" data-mp="1uogq4hkw1q2k">
                      <MinusIcon size={16} aria-hidden="true" className="mt-1 shrink-0 text-muted" data-id="element-725" data-mp="2y05v1m0qnfly" />
                      <span className="max-w-[42ch] text-small leading-6 text-muted" data-id="element-726" data-mp="2t2duy4pxwn6o">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </Reveal>
      </Container>
    </Section>;
}